
/* eslint-disable no-console */

/* Explanation:
** js-obs: TOGGLE the in-view class EVERY TIME
** js-obsp: TOGGLE the in-view class ONCE
*/

(() => {
  'use strict';

  const options = {
          threshold: 1.0
        },
        observables = document.querySelectorAll('.js-obs, .js-obsp');

  observables.forEach(observable => {
    const observer = new IntersectionObserver(entries => {
      if (!(observable.classList.contains('js-obsp') &&
           observable.classList.contains('in-view'))) {
        observable.classList.toggle('in-view', entries[0].isIntersecting);
      }
    }, options);

    observer.observe(observable);
  });
})();
